import { Component, Input } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import { KeyValuePipe } from '@angular/common';

@Component({
    selector: 'input-validators',
    templateUrl: './input-validators.component.html',
    styleUrls: ['./input-validators.component.scss'],
    imports: [KeyValuePipe]
})

export class InputValidatorsComponent {
    @Input() controlName: String = '';
    @Input() controlParent?: String = '';
    @Input() control: UntypedFormControl = null;
}
